import "./LeaguePage.css";
import TextBubble from "../../TextBubble/TextBubble";
import { useState,useEffect } from "react";
import { fetchLeagueLeaderboardData } from "../../../fetchFromDB";
import ExternalLink from "../../ExternalLink/ExternalLink";

export default function LeaguePage() {
    const [seasonData, setSeasonData] = useState(null);
    useEffect(() => {
        const loadData = async () => {
            try {
                const data = await fetchLeagueLeaderboardData([1, 2, 3]);
                setSeasonData(data);
            } catch (error) {
                console.error("Failed to load league data", error);
            }
        };
        loadData();
    }, []);

    function coloredValue(val, invert = false) {
        const positive = invert ? "#DB3900" : "#29A22F";
        const negative = invert ? "#29A22F" : "#DB3900";
        const color = val > 0 ? positive : val < 0 ? negative : undefined;
        return <span style={{ color }}>{val}</span>;
    }

    function renderTable(rows, includeGamesPlayed) {
        if (!rows) return <p>No data available.</p>;
        return (
            <div className="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Points</th>
                        <th>Penalty</th>
                        <th>Net Points</th>
                        {includeGamesPlayed && <th>Games Played</th>}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, i) => (
                        <tr key={i}>
                            <td>
                                {row["user-profile"]?.first_name} {row["user-profile"]?.middle_name} {row["user-profile"]?.last_name}
                            </td>
                            <td>{coloredValue(row.points)}</td>
                            <td>{coloredValue(row.point_penalty, true)}</td>
                            <td>{coloredValue(row.net_points)}</td>
                            {includeGamesPlayed && <td>{row.games_played}</td>}
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
        );
    }

    function renderSeasonData(seasonData) {
        const seasons = Object.keys(seasonData).sort((a, b) => b - a);
        const output = [];
        for (const season of seasons) {
            const { qualifier, finals } = seasonData[season];
            qualifier?.sort((a, b) => b.net_points - a.net_points);
            finals?.sort((a, b) => b.net_points - a.net_points);
            output.push(
                <TextBubble key={season} title={`Season ${season}`} doLoadExpanded={season === seasons[0]}>
                    <h2>Finals</h2>
                    {renderTable(finals, false)}
                    <h2>Regular Season</h2>
                    {renderTable(qualifier, true)}
                </TextBubble>
            );
        }
        return output;
    }

    return (
        <div id="league-page">
            <h1>KCRM Fountain League</h1>
            <p><b>The KCRM Fountain League</b> is an in-house league that aims to provide a
                standard and organized platform for KCRM players to compete in. If you would like to
                participate in league play with KCRM please fill out the form below. </p>
            <TextBubble>
                <ExternalLink buttonType="wide" href="https://forms.gle/NXFYX1SzRdgmRenT6">
                    Register here!
                </ExternalLink>
            </TextBubble>
            {seasonData && renderSeasonData(seasonData)}
        </div>
    )
}